import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { AlertTriangle, PackageCheck, ChevronRight } from "lucide-react";

/** Compact low-stock summary so the cashier can restock without leaving the till. */
export const LowStockPanel = () => {
  const { t } = useI18n();
  const [items, setItems] = useState(null);

  useEffect(() => {
    api
      .get("/alerts/low-stock")
      .then(({ data }) => setItems(data.items || []))
      .catch(() => setItems([]));
  }, []);

  if (items === null) return null;

  if (items.length === 0) {
    return (
      <div
        className="flex items-center gap-2 rounded-2xl border border-gray-200 bg-white px-4 py-3 text-sm text-muted-foreground"
        data-testid="low-stock-panel-empty"
      >
        <PackageCheck size={16} className="text-emerald-600" /> {t("stock_all_ok")}
      </div>
    );
  }

  return (
    <div
      className="rounded-2xl border border-amber-200 bg-amber-50/70 p-4 space-y-2"
      data-testid="low-stock-panel"
    >
      <div className="flex items-center justify-between gap-2">
        <p className="font-display font-semibold text-sm flex items-center gap-2 text-amber-900">
          <AlertTriangle size={16} /> {t("low_stock_title")} · {items.length}
        </p>
        <Link
          to="/stok"
          data-testid="low-stock-goto-stok"
          className="text-xs font-medium text-amber-900 hover:underline flex items-center"
        >
          {t("nav_stok")} <ChevronRight size={13} />
        </Link>
      </div>
      <div className="flex flex-wrap gap-2">
        {items.slice(0, 8).map((p) => (
          <span
            key={p.id || p.name}
            data-testid={`low-stock-item-${p.name}`}
            className="rounded-full bg-white border border-amber-200 px-3 py-1 text-xs"
          >
            {p.name}
            <span className="num font-semibold text-amber-700">
              {" "}
              {p.stock} {p.unit}
            </span>
          </span>
        ))}
        {items.length > 8 && (
          <span className="text-xs text-amber-900 self-center">+{items.length - 8}</span>
        )}
      </div>
    </div>
  );
};
